import * as echarts from 'echarts'
import allGeoJson from './allGeoJson'
function initGeoJson () {
    for (const item in allGeoJson) {
        echarts.registerMap(item, {geoJSON: allGeoJson[item]})
    }
}
initGeoJson()



// WEBPACK FOOTER //
// ./src/assets/geoJson/initGeoJson.js